module.exports = __webpack_public_path__ + "static/media/midautumn.726cb9d8.jpg";